import React, { memo } from 'react';

const CredentialsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M9.778 25.778c-5.4 0-9.778-4.378-9.778-9.778s4.378-9.778 9.778-9.778c4.476 0 8.25 3.008 9.41 7.113l11.034-0.002c0.982 0 1.778 0.796 1.778 1.778s-0.796 1.778-1.778 1.778h-1.778v6.222c0 0.982-0.796 1.778-1.778 1.778s-1.778-0.796-1.778-1.778v-6.222l-5.373 0.001c-0.449 4.983-4.638 8.888-9.738 8.888zM9.778 9.778c-3.436 0-6.222 2.786-6.222 6.222s2.786 6.222 6.222 6.222c3.436 0 6.222-2.786 6.222-6.222s-2.786-6.222-6.222-6.222z"
        />
    </svg>
);

export default memo(CredentialsIcon);
